import { render, staticRenderFns } from "./lp-brand-message-2.vue?vue&type=template&id=1b8dbd59&scoped=true"
import script from "./lp-brand-message-2.vue?vue&type=script&lang=js"
export * from "./lp-brand-message-2.vue?vue&type=script&lang=js"
import style0 from "./lp-brand-message-2.vue?vue&type=style&index=0&id=1b8dbd59&prod&scoped=true&lang=css"
import style1 from "./lp-brand-message-2.vue?vue&type=style&index=1&id=1b8dbd59&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8dbd59",
  null
  
)

export default component.exports